
// document.addEventListener('DOMContentLoaded', function () {
//   initLoaderOnce();
// });
// document.addEventListener('shopify:section:load', function () {
//   initLoaderOnce();
// });

// function initLoaderOnce() {
//   const hasSeenLoader = localStorage.getItem('pf_loader_shown');

//   if (!hasSeenLoader) {
//     loadingLoader();

//     // localStorage.setItem('pf_loader_shown', 'true');
//   } else {
//     const loader = document.getElementById('pfLoader');
//     if (loader) {
//       loader.style.display = 'none';
//     }
//   }
// }

// function loadingLoader() {
//   const loader = document.getElementById('pfLoader');
//   const path1 = document.getElementById('outlinePath1');
//   const path2 = document.getElementById('outlinePath2');
//   const heatFill = document.getElementById('heatFill');
//   const wipeRect = document.getElementById('wipeRect');
//   const glowBg = document.getElementById('glowBg');
//   const pctText = document.getElementById('pctText');
//   const statusText = document.getElementById('statusText');
//   const ring1 = document.getElementById('ring1');
//   const ring2 = document.getElementById('ring2');
//   const clip = document.getElementById('figureClip');

//   const len1 = path1.getTotalLength();
//   const len2 = path2.getTotalLength();

//   path1.style.strokeDasharray = len1;
//   path1.style.strokeDashoffset = len1;
//   path2.style.strokeDasharray = len2;
//   path2.style.strokeDashoffset = len2;

//   const tl = gsap.timeline({ defaults: { ease: 'power2.inOut' } });

//   tl.to(pctText, { opacity: 1, duration: 0.4 }, 0);

//   tl.set(path1, {
//     stroke: "#dcbea080"
//   }, 0.2);
//   tl.set(path2, {
//     stroke: "#dcbea080"
//   }, 0.2);

//   tl.to(path1, {
//     strokeDashoffset: 0,
//     duration: 2.8,
//     ease: 'power1.inOut',
//     onUpdate: function() {
//       const progress = 1 - (parseFloat(path1.style.strokeDashoffset || len1) / len1);
//       const pct = Math.round(progress * 50);
//       pctText.textContent = String(pct).padStart(3, '0') + '%';
//     }
//   }, 0.2);

//   tl.to(path2, {
//     strokeDashoffset: 0,
//     duration: 2.8,
//     ease: 'power1.inOut',
//   }, 0.4);

//   tl.to(glowBg, { opacity: 0.6, duration: 1.5, ease: 'power2.out' }, 1.5);
//   tl.set(heatFill, { opacity: 1 }, 3.1);
//   tl.to(wipeRect, {
//     attr: { y: 0 },
//     duration: 1.8,
//     ease: 'power2.inOut',
//     onUpdate: function() {
//       const rectY = parseFloat(wipeRect.getAttribute('y'));
//       const fillProgress = 1 - (rectY / 1080);
//       const pct = Math.round(50 + fillProgress * 50);
//       pctText.textContent = String(pct).padStart(3, '0') + '%';
//     }
//   }, 3.2).to(clip,{display: "none"});

//   tl.to(glowBg, {
//     background: 'radial-gradient(circle, rgba(200,30,10,0.35) 0%, transparent 65%)',
//     opacity: 1,
//     duration: 1.8,
//     ease: 'power2.out'
//   }, 3.2);

//   tl.to([path1, path2], {
//     opacity: 0,
//     duration: 1.2,
//     ease: 'power2.out'
//   }, 3.6);

//   tl.to(statusText, { opacity: 1, duration: 0.5 }, 0.5);
//   tl.to(statusText, { opacity: 0, duration: 0.4 }, 4.8);

//   // Rings pulse out at the end
//   tl.to([ring1, ring2], { opacity: 0.6, duration: 0.3 }, 4.8);
//   tl.to(ring1, {
//     scale: 1.3,
//     opacity: 0,
//     duration: 1.2,
//     ease: 'power2.out',
//     transformOrigin: '50% 50%'
//   }, 4.8);
//   tl.to(ring2, {
//     scale: 1.5,
//     opacity: 0,
//     duration: 1.6,
//     ease: 'power2.out',
//     transformOrigin: '50% 50%'
//   }, 4.9);

//   // Final percent lock to 100
//   tl.to(pctText, {
//     opacity: 0,
//     duration: 0.6,
//     delay: 0.3
//   }, 5.0)
//   .to(loader,{
//     display: "none",
//   })
// };



// page load
class PFPageLoad extends HTMLElement {
    constructor() {
        super();

        this.hasSeenLoader = localStorage.getItem('pf_loader_shown') || document.body.dataset.customerEmail;
        this.header = document.querySelector("#header-group");
        this.main_content = document.querySelector("#MainContent");

        this.logoTexts = [
            "Take Your Time",
            "This Is Enough",
            "Stay With It",
            "Let It Be",
            "It Can Wait",
            "You’re Doing Fine",
            "Breathe Then Decide",
            "Give It Time",
            "Stay A Little",
            "Nothing Stays Forever"
        ];


        this.duration = 0.8;
        this.easing = "power2.inOut";
        this.loader_elm = `
            <div class="pf-loader-wrap">
            <div class="ring" id="ring1" style="width:340px;height:340px;"></div>
            <div class="ring" id="ring2" style="width:380px;height:380px;"></div>
            <div class="glow-bg" id="glowBg"></div>

            <svg class="main-svg" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <!-- Clip path using the filled shape -->
                <clipPath id="figureClip">
                  <path id="clipShape1" d="M773.09,533.41c-3.17-11.3,11.31-20.12,5.78-30.78-.34-.67-8.32-11.61-8.84-12.16-3.59-3.79-10.31-2.97-11.64-9.45-1.33-6.5-1.26-14.78-3.05-21.86-3.01-11.92-12.66-32.79-13.29-43.8-.48-8.3,8.39-7.21,7.75-13.57-.99-9.87-6.68-7.09-8.64-10.45-1.19-2.03-1.45-6.55-2.67-9.33-1.9-4.34-4.81-7.8-6.53-12.47-8.57-23.29-1.34-43.68-7.41-66.59-1.14-4.29-3.12-8.72-5.55-12.45l-37.58-34.42c-7.5-15.48,11.08-22.13,19.98-31.18,7.72-7.86,12.87-17.91,19.62-26.38,2.43-3.05,8.98-7.78,10.23-10.77.89-2.15,3.77-20.52,3.79-23.3.08-11.7-3.29-19.5-12.03-26.96-6.11-5.23-14.61-8.33-20.51-13.49-7.64-6.69-8.75-13.93-18.48-19.52-11.37-6.52-35.45-8.18-47.82-4.78-36.2,9.93-46.87,64.63-49.19,96.81-.67,9.29,2.36,22.42-4,30-4.92,5.88-16.18,4.47-23.81,7.19-2.84,1.02-5,3.06-7.94,4.06-19.01,6.46-27.26,4.52-39.05,22.95-16.48,25.74-27.39,66.78-38.19,95.81-6.74,18.12-14.32,26.27-11.91,47.87.78,7.08,4.5,12.28,3.88,20.1-.63,7.89-6.61,15.98-7.75,23.25-.65,4.15-1.41,16.54-1.29,20.73.11,3.95,14.49,41.31,17.23,45.85,2.14,3.55,8.63,9.88,9.27,13.55.51,2.91-1.85,13.57-2.07,17.8-.22,4.1,1.28,9.06.56,13.77-.63,4.08-4.23,8.68-4.85,13.15-2.11,14.97,4.68,15.11,12.99,24.83,5.46.74,13.85,7.08,17.91,8.14,2.75.72,4.94-.49,6.74.17,2.77,1.01,7.32,7.52,11.34,1.84,3.96-5.6-2.18-12.56-2.06-18.56,4.15-.79,6.51,8.74,7.66,9.03,3.46.86,7.31-.65,9.81-3.05,2.42-8.42-3.83-16.08-5.22-23.75-1.51-8.28-.55-17.21-6.15-24.76,1.84-2.47,5.08-2.64,7.89-2.48-.41-6.97-6.48-26.68-4.8-32.29,1.13-3.78,11.4-3.91,13.66-1.07,2.45,7.35-4.95,11.24-4.83,14.72.08,2.59,2.07,7.42,2.72,10.39,2.59,11.82,12.55,57.26,11.19,66.7-2.72,18.91-3.35,45.63-1.98,65.09.8,11.28,7.48,24.68-.1,34.82-1.9,2.55-7.23,4.91-8.75,7.25-1.9,2.91-1.68,8.28-3.9,12.1-1.87,3.2-4.3,3.64-6.07,5.93-7.92,10.26-26.96,52.26-29.04,64.96-2.78,17.06-3,36.69-8.82,53.18-2.49,7.06-10.94,16.48-14.32,23.67-5.15,10.95,5.57,17.83,11.04,26.07-.99,9.49-8.6,17.61-2.85,26.87.69,1.11,2.51,1.29,2.84,2.35.77,2.51-.1,5.98,1.59,9.18,4.86,9.21,18.84,3.13,26.91,4.07,10.92-1.21,17.06-5.86,28.43-.37,8.17,3.95,8.98,3.1,17.53,5.43,9.95,2.72,16.64,7.88,28.52,3.98.91,3.81,2.01,9.31,3.82,12.68,1.25,2.31,4.06,3.95,4.77,6.23,1.47,4.74-1.15,8.81,4.53,12.47,9.65,6.25,20.04,2.43,28.2,4.8,1.33.39,4.63,3.44,7.44,4.56,15.13,6.01,70.09,10.81,85.52,6.99,2.54-.63,7.69-2.96,8.25-5.77.31-1.56-2.31-2.45-1.04-4.02,10.85-2.78,13.92-6.97,13.55-18.43-.61-18.89-12.55-22.56-28.63-25.42-4.72-.84-10.38,1.27-13.83-4.17-7.08-11.11,5.67-23.27-2.12-34.88-1.4-2.1-3.97-3.49-5.28-5.72-4.59-7.78-1.38-40.47-2.11-51.89-.46-7.19-3.18-15.72-3.13-22.96.15-21.65,11.2-50.37,12.97-73.12,2-25.81-4.74-51.73-11.16-76.6-4.38-16.92-9.64-33.75-14.42-50.58-1.7-5.99-6.56-17.11-6.31-22.67.75-16.72,4.73-34.61,5.47-51.57,2.73-7.74,8.6-1.64,13.92-6.07,4.37-3.64,1.27-13.46-1.17-17.6-1.7-2.87-5.85-3.84-5.11-6.62,1.05-3.91,14.55-5.38,17.21-3.73,1.04.66,1.42,2.73,3.31,3.94,6.59,4.25,23.3,5.88,26.45,13.55.64,1.53,4.26,11.5,4.48,12.55.59,2.76-1.07,7.96-.31,12.29,1.28,7.36,5.73,17.18,7.52,24.47.37,1.53,2.32,10.97,2.3,11.79-.12,4.87-20.68,21.11-7.35,24.25,13.69,3.23,25.47-8.6,32.67-18.41,6.82-9.28,3.23-6.29,6.06-15.43,1.09-3.48,6.62-5.95,6.62-11.44l-16.97-37.09ZM621.71,821.21c-2.41,8.52-20.71,42.55-20.71,46.29v39.5l-6.03-15.47c-.9-7.28.16-33,2.27-39.79,3.02-9.71,15.56-22.92,19.17-32.83,1.37-3.76,1.21-7.97,2.25-11.75,3.86-14.02,7.87-28.04,11.35-42.15l1.03,8.53c-5.45,14.98-5.15,32.88-9.33,47.67Z"/>
                  <path id="clipShape2" d="M520.92,716.58c-4.66-2.9-14.09-5.88-17.45-8.55-2.69-2.14-5.73-9.48-8.47-12.53-2.56-2.85-7.42-5.15-9.46-8.54-5.1-8.44.08-16.58-2.32-24.68-1.79-6.05-7.78-8.78-11.73-13.27-4.17-4.72-7.66-10.11-12.25-14.5,6.87-8.39,11.62-16.7,16.55-26.22,2.09-4.04,5.52-5.86,5.27-11.77-.2-4.88-5.46-7.53-6.61-11.48-3.73-12.87,3.15-17.05,4.46-26.62.69-5.05-1.02-8.73-.95-12.87.09-5.34,2.99-12.58,1.84-17.83-.75-3.39-6.46-8.88-8.6-12.42-2.88-4.75-16.82-41.12-17.21-45.81-.5-5.93.65-19.9,2.29-25.71,1.69-5.97,6.23-13.25,6.74-19.28.69-8.35-4.82-18.49-4.82-28,0-15.52,6.72-24.73,11.82-37.98,3.74-9.69,5.49-20.07,9.22-29.78,3.61-9.42,8.83-18.74,12.51-28.49,2.91-7.74,5.35-15.78,8.01-23.61-.34-3.3-12.69-14.57-15.84-17.06-4.37-3.44-14.78-8.63-17.87-12.13-3.66-4.14-7.63-16.99-12-21-2.62-2.41-8.49-3.2-8.87-3.63-.44-.49-1.25-7.7-1.88-9.62-9.01-27.71-24.87-62.25-60.56-47.96-10.45,4.19-22.96,19.77-26.79,30.21-2.22,6.05-1.91,12.51-3.42,18.58-1.79,7.19-6.44,12.25-5.45,20.37.87,7.23,9.19,20.4,13.94,26.08,3.34,3.99,9.21,5.08,7.81,11.79-10.36,17.82-23.13,34.92-33.25,52.81-9.79,17.32-16.42,43.17-22.29,62.71-12.97,43.12-26.38,89.32-37.01,132.99-3.43,14.12-3.8,22.58-5.54,36.46-.98,7.88-5.86,17.95-6.51,25.53-.15,1.69.08,3.16,1.49,4.28,5.14,4.13,32.59,10.21,39.9,10.82,3.63.31,10.68.8,12.64-3.11,2.03-4.03,2.82-15.16,4.46-20.54,1.07-3.5,8.38-21.96,11.77-21.21,2.36,1.96.36,5.35,4.01,5.99h27c1.43.88,1.38,1.99,1.55,3.45,1.88,15.98-2.54,34.5-1.03,51.03.36,4,2.24,7.82,2.75,11.25,1.59,10.83-.65,21.19-.81,31.73-.51,33.88,3.87,75.07,8.18,108.9,1.24,9.7,6.48,22.84,6.79,31.29.15,4.08-2.01,8.84-2.01,12.85.01,4.07,3.11,10.06,3.07,12.03-.05,2.73-6.14,4.24-1.34,11.22,1.29,1.88,4.39,2.35,4.37,4.73l-3.7,5.4c-10.68-1.04-17.89-3.03-26.85,4.09-13.8,10.98-19.52,29.49,2.28,34.78,18.4,4.45,39.01,2.52,57.74,3.26,14.23.56,29.01,3.42,44.05,2.03,3.06-.28,5.83-.94,8.49-2.51,2.72-13.81,6.46-28.57.02-42.08-1.39-2.91-5.98-5.88-6.03-7.92-.09-4.02,7.24-9.99,7.53-12.98.51-5.35-2.74-20.55-3.87-26.73-1.39-7.66-4.16-15.01-4.67-22.82l5.47,9.02c4.05,3.56,7.44,7.97,11.51,11.49,7.89,6.85,14.55,5.06,9.2,18.18-1.82,4.45-6.66,8.4-7.91,12.09-1.79,5.23-3.44,25.78,2.66,27.78,7.06,2.32,10.05-1.27,11.77-7.35,4.3-15.25,5.15-31.13,7.41-46.59,3.58-24.49,19.71-47.99,29.86-70.15-.06-2.61-8.64-8.39-11.06-9.89ZM458.12,752.38l-6.11-54.38,6.89,23.6,3.09,49.39-3.87-18.61Z"/>
                </clipPath>

                <!-- Reveal clip: horizontal wipe from bottom to top -->
                <clipPath id="wipeClip">
                  <rect id="wipeRect" x="0" y="1080" width="1080" height="1080"/>
                </clipPath>
              </defs>

              <!-- Heatmap image clipped to figure shape -->
              <!-- <g clip-path="url(#figureClip)" class="fill-path" id="heatFill"> -->
              <g class="fill-path" id="heatFill">
                <image
                  href="https://cdn.shopify.com/s/files/1/0738/8941/5213/files/ab107c04-3446-45c7-bdb9-c80d61dbc421.jpg"
                  x="-90" y="3"
                  width="1255" height="1062"
                  clip-path="url(#wipeClip)"
                  preserveAspectRatio="xMidYMid meet"
                />
              </g>

              <!-- Outline paths drawn via stroke-dashoffset -->
              <path id="outlinePath1" class="outline-path"
                d="M785.59,522.52c-3.17-11.3,11.31-20.12,5.78-30.78-.34-.67-8.32-11.61-8.84-12.16-3.59-3.79-10.31-2.97-11.64-9.45-1.33-6.5-1.26-14.78-3.05-21.86-3.01-11.92-12.66-32.79-13.29-43.8-.48-8.3,8.39-7.21,7.75-13.57-.99-9.87-6.68-7.09-8.64-10.45-1.19-2.03-1.45-6.55-2.67-9.33-1.9-4.34-4.81-7.8-6.53-12.47-8.57-23.29-1.34-43.68-7.41-66.59-1.14-4.29-3.12-8.72-5.55-12.45l-37.58-34.42c-7.5-15.48,11.08-22.13,19.98-31.18,7.72-7.86,12.87-17.91,19.62-26.38,2.43-3.05,8.98-7.78,10.23-10.77.89-2.15,3.77-20.52,3.79-23.3.08-11.7-3.29-19.5-12.03-26.96-6.11-5.23-14.61-8.33-20.51-13.49-7.64-6.69-8.75-13.93-18.48-19.52-11.37-6.52-35.45-8.18-47.82-4.78-36.2,9.93-46.87,64.63-49.19,96.81-.67,9.29,2.36,22.42-4,30-4.92,5.88-16.18,4.47-23.81,7.19-2.84,1.02-5,3.06-7.94,4.06-19.01,6.46-27.26,4.52-39.05,22.95-16.48,25.74-27.39,66.78-38.19,95.81-6.74,18.12-14.32,26.27-11.91,47.87.78,7.08,4.5,12.28,3.88,20.1-.63,7.89-6.61,15.98-7.75,23.25-.65,4.15-1.41,16.54-1.29,20.73.11,3.95,14.49,41.31,17.23,45.85,2.14,3.55,8.63,9.88,9.27,13.55.51,2.91-1.85,13.57-2.07,17.8-.22,4.1,1.28,9.06.56,13.77-.63,4.08-4.23,8.68-4.85,13.15-2.11,14.97,4.68,15.11,12.99,24.83,5.46.74,13.85,7.08,17.91,8.14,2.75.72,4.94-.49,6.74.17,2.77,1.01,7.32,7.52,11.34,1.84,3.96-5.6-2.18-12.56-2.06-18.56,4.15-.79,6.51,8.74,7.66,9.03,3.46.86,7.31-.65,9.81-3.05,2.42-8.42-3.83-16.08-5.22-23.75-1.51-8.28-.55-17.21-6.15-24.76,1.84-2.47,5.08-2.64,7.89-2.48-.41-6.97-6.48-26.68-4.8-32.29,1.13-3.78,11.4-3.91,13.66-1.07,2.45,7.35-4.95,11.24-4.83,14.72.08,2.59,2.07,7.42,2.72,10.39,2.59,11.82,12.55,57.26,11.19,66.7-2.72,18.91-3.35,45.63-1.98,65.09.8,11.28,7.48,24.68-.1,34.82-1.9,2.55-7.23,4.91-8.75,7.25-1.9,2.91-1.68,8.28-3.9,12.1-1.87,3.2-4.3,3.64-6.07,5.93-7.92,10.26-26.96,52.26-29.04,64.96-2.78,17.06-3,36.69-8.82,53.18-2.49,7.06-10.94,16.48-14.32,23.67-5.15,10.95,5.57,17.83,11.04,26.07-.99,9.49-8.6,17.61-2.85,26.87.69,1.11,2.51,1.29,2.84,2.35.77,2.51-.1,5.98,1.59,9.18,4.86,9.21,18.84,3.13,26.91,4.07,10.92-1.21,17.06-5.86,28.43-.37,8.17,3.95,8.98,3.1,17.53,5.43,9.95,2.72,16.64,7.88,28.52,3.98.91,3.81,2.01,9.31,3.82,12.68,1.25,2.31,4.06,3.95,4.77,6.23,1.47,4.74-1.15,8.81,4.53,12.47,9.65,6.25,20.04,2.43,28.2,4.8,1.33.39,4.63,3.44,7.44,4.56,15.13,6.01,70.09,10.81,85.52,6.99,2.54-.63,7.69-2.96,8.25-5.77.31-1.56-2.31-2.45-1.04-4.02,10.85-2.78,13.92-6.97,13.55-18.43-.61-18.89-12.55-22.56-28.63-25.42-4.72-.84-10.38,1.27-13.83-4.17-7.08-11.11,5.67-23.27-2.12-34.88-1.4-2.1-3.97-3.49-5.28-5.72-4.59-7.78-1.38-40.47-2.11-51.89-.46-7.19-3.18-15.72-3.13-22.96.15-21.65,11.2-50.37,12.97-73.12,2-25.81-4.74-51.73-11.16-76.6-4.38-16.92-9.64-33.75-14.42-50.58-1.7-5.99-6.56-17.11-6.31-22.67.75-16.72,4.73-34.61,5.47-51.57,2.73-7.74,8.6-1.64,13.92-6.07,4.37-3.64,1.27-13.46-1.17-17.6-1.7-2.87-5.85-3.84-5.11-6.62,1.05-3.91,14.55-5.38,17.21-3.73,1.04.66,1.42,2.73,3.31,3.94,6.59,4.25,23.3,5.88,26.45,13.55.64,1.53,4.26,11.5,4.48,12.55.59,2.76-1.07,7.96-.31,12.29,1.28,7.36,5.73,17.18,7.52,24.47.37,1.53,2.32,10.97,2.3,11.79-.12,4.87-20.68,21.11-7.35,24.25,13.69,3.23,25.47-8.6,32.67-18.41,6.82-9.28,3.23-6.29,6.06-15.43,1.09-3.48,6.62-5.95,6.62-11.44l-16.97-37.09h0ZM634.21,810.32c-2.41,8.52-20.71,42.55-20.71,46.29v39.5l-6.03-15.47c-.9-7.28.16-33,2.27-39.79,3.02-9.71,15.56-22.92,19.17-32.83,1.37-3.76,1.21-7.97,2.25-11.75,3.86-14.02,7.87-28.04,11.35-42.15l1.03,8.53c-5.45,14.98-5.15,32.88-9.33,47.67h0Z"
              />
              <path id="outlinePath2" class="outline-path"
                d="M533.42,705.69c-4.66-2.9-14.09-5.88-17.45-8.55-2.69-2.14-5.73-9.48-8.47-12.53-2.56-2.85-7.42-5.15-9.46-8.54-5.1-8.44.08-16.58-2.32-24.68-1.79-6.05-7.78-8.78-11.73-13.27-4.17-4.72-7.66-10.11-12.25-14.5,6.87-8.39,11.62-16.7,16.55-26.22,2.09-4.04,5.52-5.86,5.27-11.77-.2-4.88-5.46-7.53-6.61-11.48-3.73-12.87,3.15-17.05,4.46-26.62.69-5.05-1.02-8.73-.95-12.87.09-5.34,2.99-12.58,1.84-17.83-.75-3.39-6.46-8.88-8.6-12.42-2.88-4.75-16.82-41.12-17.21-45.81-.5-5.93.65-19.9,2.29-25.71,1.69-5.97,6.23-13.25,6.74-19.28.69-8.35-4.82-18.49-4.82-28,0-15.52,6.72-24.73,11.82-37.98,3.74-9.69,5.49-20.07,9.22-29.78,3.61-9.42,8.83-18.74,12.51-28.49,2.91-7.74,5.35-15.78,8.01-23.61-.34-3.3-12.69-14.57-15.84-17.06-4.37-3.44-14.78-8.63-17.87-12.13-3.66-4.14-7.63-16.99-12-21-2.62-2.41-8.49-3.2-8.87-3.63-.44-.49-1.25-7.7-1.88-9.62-9.01-27.71-24.87-62.25-60.56-47.96-10.45,4.19-22.96,19.77-26.79,30.21-2.22,6.05-1.91,12.51-3.42,18.58-1.79,7.19-6.44,12.25-5.45,20.37.87,7.23,9.19,20.4,13.94,26.08,3.34,3.99,9.21,5.08,7.81,11.79-10.36,17.82-23.13,34.92-33.25,52.81-9.79,17.32-16.42,43.17-22.29,62.71-12.97,43.12-26.38,89.32-37.01,132.99-3.43,14.12-3.8,22.58-5.54,36.46-.98,7.88-5.86,17.95-6.51,25.53-.15,1.69.08,3.16,1.49,4.28,5.14,4.13,32.59,10.21,39.9,10.82,3.63.31,10.68.8,12.64-3.11,2.03-4.03,2.82-15.16,4.46-20.54,1.07-3.5,8.38-21.96,11.77-21.21,2.36,1.96.36,5.35,4.01,5.99h27c1.43.88,1.38,1.99,1.55,3.45,1.88,15.98-2.54,34.5-1.03,51.03.36,4,2.24,7.82,2.75,11.25,1.59,10.83-.65,21.19-.81,31.73-.51,33.88,3.87,75.07,8.18,108.9,1.24,9.7,6.48,22.84,6.79,31.29.15,4.08-2.01,8.84-2.01,12.85.01,4.07,3.11,10.06,3.07,12.03-.05,2.73-6.14,4.24-1.34,11.22,1.29,1.88,4.39,2.35,4.37,4.73l-3.7,5.4c-10.68-1.04-17.89-3.03-26.85,4.09-13.8,10.98-19.52,29.49,2.28,34.78,18.4,4.45,39.01,2.52,57.74,3.26,14.23.56,29.01,3.42,44.05,2.03,3.06-.28,5.83-.94,8.49-2.51,2.72-13.81,6.46-28.57.02-42.08-1.39-2.91-5.98-5.88-6.03-7.92-.09-4.02,7.24-9.99,7.53-12.98.51-5.35-2.74-20.55-3.87-26.73-1.39-7.66-4.16-15.01-4.67-22.82l5.47,9.02c4.05,3.56,7.44,7.97,11.51,11.49,7.89,6.85,14.55,5.06,9.2,18.18-1.82,4.45-6.66,8.4-7.91,12.09-1.79,5.23-3.44,25.78,2.66,27.78,7.06,2.32,10.05-1.27,11.77-7.35,4.3-15.25,5.15-31.13,7.41-46.59,3.58-24.49,19.71-47.99,29.86-70.15-.06-2.61-8.64-8.39-11.06-9.89h0ZM470.62,741.49l-6.11-54.38,6.89,23.6,3.09,49.39-3.87-18.61h0Z"
              />
            </svg>

            <div class="scanlines"></div>
            <div class="pct" id="pctText">000%</div>
            <div class="status" id="statusText">SCANNING<span class="blink">_</span></div>
          </div>
        `
    }

    connectedCallback() {
        if (this.hasSeenLoader) {
          this.innerHTML = `<h1 class="logo">${this._getRandomText()}</h1>`
          this._bindLinks();
          this._handlePageLoad();
        } else {
          this.innerHTML = this.loader_elm;
          this._initLoader();
        }
    }

    _initLoader() {
        const loader = this;
        const path1 = document.getElementById('outlinePath1');
        const path2 = document.getElementById('outlinePath2');
        const heatFill = document.getElementById('heatFill');
        const wipeRect = document.getElementById('wipeRect');
        const glowBg = document.getElementById('glowBg');
        const pctText = document.getElementById('pctText');
        const statusText = document.getElementById('statusText');
        const ring1 = document.getElementById('ring1');
        const ring2 = document.getElementById('ring2');
        const clip = document.getElementById('figureClip');

        const len1 = path1.getTotalLength();
        const len2 = path2.getTotalLength();

        path1.style.strokeDasharray = len1;
        path1.style.strokeDashoffset = len1;
        path2.style.strokeDasharray = len2;
        path2.style.strokeDashoffset = len2;

        const tl = gsap.timeline({
            defaults: {
                ease: 'power2.inOut'
            }
        });

        tl.to(pctText, {
            opacity: 1,
            duration: 0.4
        }, 0);

        tl.set(path1, {
            stroke: "#dcbea080"
        }, 0.2);
        tl.set(path2, {
            stroke: "#dcbea080"
        }, 0.2);

        tl.to(path1, {
            strokeDashoffset: 0,
            duration: 2.8,
            ease: 'power1.inOut',
            onUpdate: function() {
                const progress = 1 - (parseFloat(path1.style.strokeDashoffset || len1) / len1);
                const pct = Math.round(progress * 50);
                pctText.textContent = String(pct).padStart(3, '0') + '%';
            }
        }, 0.2);

        tl.to(path2, {
            strokeDashoffset: 0,
            duration: 2.8,
            ease: 'power1.inOut',
        }, 0.4);

        tl.to(glowBg, {
            opacity: 0.6,
            duration: 1.5,
            ease: 'power2.out'
        }, 1.5);
        tl.set(heatFill, {
            opacity: 1
        }, 3.1);
        tl.to(wipeRect, {
            attr: {
                y: 0
            },
            duration: 1.8,
            ease: 'power2.inOut',
            onUpdate: function() {
                const rectY = parseFloat(wipeRect.getAttribute('y'));
                const fillProgress = 1 - (rectY / 1080);
                const pct = Math.round(50 + fillProgress * 50);
                pctText.textContent = String(pct).padStart(3, '0') + '%';
            }
        }, 3.2).to(clip, {
            display: "none"
        });

        tl.to(glowBg, {
            background: 'radial-gradient(circle, rgba(200,30,10,0.35) 0%, transparent 65%)',
            opacity: 1,
            duration: 1.8,
            ease: 'power2.out'
        }, 3.2);

        tl.to([path1, path2], {
            opacity: 0,
            duration: 1.2,
            ease: 'power2.out'
        }, 3.6);

        tl.to(statusText, {
            opacity: 1,
            duration: 0.5
        }, 0.5);
        tl.to(statusText, {
            opacity: 0,
            duration: 0.4
        }, 4.8);

        tl.to([ring1, ring2], {
            opacity: 0.6,
            duration: 0.3
        }, 4.8);
        tl.to(ring1, {
            scale: 1.3,
            opacity: 0,
            duration: 1.2,
            ease: 'power2.out',
            transformOrigin: '50% 50%'
        }, 4.8);
        tl.to(ring2, {
            scale: 1.5,
            opacity: 0,
            duration: 1.6,
            ease: 'power2.out',
            transformOrigin: '50% 50%'
        }, 4.9);

        tl.to(pctText, {
                opacity: 0,
                duration: 0.6,
                delay: 0.3
            }, 5.0)
            .to(loader, {
                opacity: 0,
                onComplete: () => {
                    console.log("im here");
                    this.innerHTML = `<h1 class="logo">${this._getRandomText()}</h1>`
                    this._bindLinks();
                    this._handlePageLoad();
                    localStorage.setItem('pf_loader_shown', 'true');
                },
            })
    };

    _bindLinks() {
        document.addEventListener("click", (e) => {
            const link = e.target.closest("a[href]");
            if (!link ) return;

            const url = link.href;
            if (
                !url ||
                e.metaKey ||
                e.ctrlKey ||
                link.target === "_blank" ||
                link.href === window.location.href ||
                !url.includes("https://offculturee.com/") ||
                link.href.replace(window.location.href, "") === "#" ||
                link.href.replace(window.location.href, "") === "/#"
            ) {
                return;
            }


            e.preventDefault();
            this._navigate(url);
        });
    }

    _navigate(url) {
        const tl = gsap.timeline({
            defaults: {
                duration: this.duration,
                ease: this.easing,
            },
            onComplete: () => {
                window.location.href = url;
            },
        });
        gsap.set(this, {
            yPercent: 100,
            scale: 1,
            opacity: 1
        });

        gsap.set(this.header, {
            position: "relative",
            display: "block"
        });


        tl.to(this.header, { y: -200 })
        tl.to(this.main_content, { y: -200 }, "<")
        .to(this, {yPercent: 0},0);
    }

    _handlePageLoad() {
        window.addEventListener("load", () => {e;

            const tl = gsap.timeline({
                defaults: {
                    duration: this.duration,
                    ease: this.easing,
                },
            });
            gsap.set(this, { yPercent: 0 });
            gsap.set(this.main_content, { y: 200 });
            gsap.set(this.header, {
                y: 100,
                position: "relative",
                display: "block"
            });


            tl.to(this, {yPercent: -100})
            .to(this.header, {y: 0},"-=0.8")
            .to(this.main_content, {
                y: 0,
                onComplete: ()=>{
                    gsap.set(this.header, {
                        position: "static",
                        display: "contents"
                    });
                    this.main_content.style.transform = "none";
                }
            },"<");
        });
    }

    _getRandomText() {
        return this.logoTexts[Math.floor(Math.random() * this.logoTexts.length)];
    }
}

if (!customElements.get("pf-loader")) {
    customElements.define("pf-loader", PFPageLoad);
}